import { render, staticRenderFns } from "./EditNews.vue?vue&type=template&id=3375ce88&scoped=true&"
import script from "./EditNews.vue?vue&type=script&lang=js&"
export * from "./EditNews.vue?vue&type=script&lang=js&"
import style0 from "./EditNews.vue?vue&type=style&index=0&id=3375ce88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3375ce88",
  null
  
)

export default component.exports